import React from 'react';
import HeaderLayout from 'modules/common/layouts/HeaderLayout';
import Hero from 'lib/components/ui/hero';
import Highlight from 'modules/common/components/Highlight';
import { Button } from 'lib/components/ui/button';
import Section from 'modules/common/components/Section';
import Image from 'next/image';
import { FaCocktail } from 'react-icons/fa';
import Markdown from 'lib/components/ui/markdown';
import Pricing from 'modules/Marketing/components/Pricing';
import { useAuthModal } from 'modules/auth';
import { Event } from 'modules/App/models/Event';
import RotatingFeatures from 'modules/Marketing/components/RotatingFeatures';
import { Md11Mp, MdCalendarViewDay, MdGroup, MdProductionQuantityLimits, MdWorkspaces } from 'react-icons/md';
import PlanComparison from 'modules/Marketing/components/PlanComparison';
import { formatMinutesToHoursAndMinutes } from 'utils/misc';
import { useQuery } from '@apollo/client';
import { LIST_EVENTS } from 'modules/App/data-components/EventCalendar';

import dayjs from 'lib/helpers/date';
import ToolBadge from 'modules/Marketing/components/ToolBadge';
import { ExclusiveOffer } from 'modules/Marketing/components/ExclusiveOffer';
import { SpecialOffer } from 'modules/Marketing/components/SpecialOffer';
import { linkedinDorothee } from 'modules/App/config';
import { CardBenefit } from 'lib/components/ui/card-benefit';
const pricingAtelierItems: React.ComponentProps<typeof PlanComparison>['items'] = [
  {
    plan: 'none',
    title: (
      <>
        <strong>150€</strong>
      </>
    ),
  },
  {
    plan: 'starter',
    title: (
      <>
        <strong>90€</strong>
      </>
    ),
    details: (
      <>
        Economie de <strong>50€</strong>
      </>
    ),
  },
  // {
  //   plan: 'pro',
  //   title: <strong>Gratuit *</strong>,
  //   details: (
  //     <>
  //       Economie de <strong>150€</strong>
  //       <br />* Dans la limite de 4 ateliers par mois
  //     </>
  //   ),
  // },
];

export const bonusFeatures = (
  <RotatingFeatures
    title={<>Outils, Formations, Trainings... moins chers&nbsp;!</>}
    subtitle={
      <>
        Pour un recrutement <strong>efficace</strong>, tu dois savoir <strong>prospecter</strong>, <strong>connaître</strong> ta cible, avoir une{' '}
        <strong>offre solide</strong>, et <strong>t’imposer</strong> face à tes clients. Il te faut aussi un <strong>outil de sourcing</strong> ou
        l’accès à une
        <strong>CVthèque</strong>, un bon <strong>ATS</strong>, et enfin <strong>Headlinker</strong> pour valoriser tes candidats recalés.
        <br />
        Alors on t’a organisé tout ça, et on a même négocié les prix pour toi.
      </>
    }
    items={[
      {
        id: 'prospection-collective',
        title: <>Tu as du mal à t’organiser&nbsp;? Tu procrastines la prospection&nbsp;?</>,
        subtitle: 'Rejoins nos séances de prospection collective !',
        type: 'workshop',
        icon: <MdWorkspaces />,
        details: (
          <div className="prose prose-sm text-left">
            <Markdown>
              {`**Le mardi matin, et le jeudi après midi, on prospecte ensemble dans notre maison virtuelle**
- Tu t’inscris directement dans l’agenda
- Tu te connectes avec ta liste de prospection
- Tu papotes dans la salle café avec d’autres recruteurs pendant 15 min max
- Et tu pars dans une salle dédiée avec un ou 2 autres recruteurs pour 1h30 de travail
- À la fin de la session, tu as terminé ta prospection pour la semaine :)

[Voir l'offre](/#pricing)
`}
            </Markdown>
            {/* <h3>Combien ça coûte&nbsp;?</h3>
            <PlanComparison items={pricingAtelierItems} /> */}
          </div>
        ),
      },
      {
        id: 'team',
        title: 'Tu as besoin d’une vraie équipe pour passer à l’étape supérieure ?',
        subtitle: 'Rejoins un club Team Booster mais reste indépendant !',
        type: 'tool',
        icon: <MdGroup />,
        details: (
          <div className="prose prose-sm text-left">
            <Markdown>
              {`**Les Clubs Headlinker**

- Dorothée te crée une équipe sur mesure, en fonction de ta personnalité et de tes objectifs
- le lundi matin, ton équipe se réunit pour échanger sur les succès et échecs de la semaine passée et chacun fixe ses objectifs prioraires de la semaine. Hot seat à tour de rôle : chaque semaine, un membre soumet aux autres un pb et sollicite leur avis.
- l’équipe se retrouve le mardi et/ou le jeudi en session de prospection.
- Intervention régulière de Dorothée, d’une coach, d’experts, pour progresser en continu
- Accès à un groupe WhatsApp dédié
- **ATTENTION** : liste d’attente importante

[Voir l'offre](/#pricing)
`}
            </Markdown>
            {/* <h3>Combien ça coûte&nbsp;?</h3>
            <PlanComparison items={pricingAtelierItems} /> */}
          </div>
        ),
      },
      {
        id: 'trimoji',
        title: 'L’outil d’évaluation de personnalité : Trimoji',
        subtitle: 'Simplifie tes processus de recrutement et augmente ta valeur',
        icon: <MdCalendarViewDay />,
        type: 'tool',
        details: (
          <div className="prose prose-sm text-left">
            <Image src="/images/tools/trimoji.png" width={125} height={38} alt="Trimoji" />
            <Markdown>
              {`## Trimoji c’est quoi?
              
Découvre [Trimoji](https://trimoji.fr/)

- **Augmente** la valeur perçue par tes clients
- Ajoute à ton arsenal de recruteur un outil d'**audit d'équipe facturable** immédiatement
- **Améliore ton image** auprès de tes candidats en leur fournissant leur évaluation de personnalité
- Utilise l'outil en marque blanche et **reste indépendant**
- Regarde le [Replay de présentation](https://www.youtube.com/watch?v=gMXd7IdJGNM)
- Crée ton compte Headlinker et [prends rendez-vous](https://calendly.com/davy-correia/rendez-vous-decouverte-trimoji-x-headlinker) dès maintenant pour bénéficier de la remise réservée aux membres
`}
            </Markdown>

            <h3>Combien ça coûte&nbsp;?</h3>
            <PlanComparison
              items={[
                {
                  plan: 'none',
                  title: (
                    <>
                      <strong>300€/mois</strong>
                      <br />
                      Formation à <strong>900€</strong>
                    </>
                  ),
                },
                {
                  plan: 'starter',
                  title: (
                    <>
                      <strong>250€/mois</strong>
                      <br />
                      Formation à <strong>600€</strong>
                    </>
                  ),
                  details: (
                    <>
                      Economie de <strong>17%</strong> sur l’abonnement
                      <br />
                      et <strong>33%</strong> sur la formation
                    </>
                  ),
                },
                // {
                //   plan: 'pro',
                //   title: (
                //     <>
                //       <strong>200€/mois</strong>
                //       <br />
                //       Formation à <strong>450€</strong>
                //     </>
                //   ),
                //   details: (
                //     <>
                //       Economie de <strong>33%</strong> sur l’abonnement
                //       <br />
                //       et <strong>50%</strong> sur la formation
                //     </>
                //   ),
                // },
              ]}
            ></PlanComparison>
          </div>
        ),
      },
      //       {
      //         id: 'prospection',
      //         title: 'Formation "3 placements minimum en 90 jours"',
      //         subtitle: 'Prospection et stratégie commerciale + nouvelles méthodes de sourcing',
      //         icon: <Md11Mp />,
      //         type: 'training',
      //         details: (
      //           <div className="prose prose-sm text-left">
      //             <Image src="https://files.headlinker.com/users/linkedin/Pg7-Fm6yps.jpeg" width={64} height={64} alt="Trimoji" />
      //             <Markdown>
      //               {`
      // ### Avec [Kemra Jaafar](https://recrutech-and-co.fr/) de Recrutech & Co

      // - Coaching 1 to 1 avec des experts en **prospection**
      // - Coaching 1 to 1 avec Kemra pour **co-construire ta stratégie** de recrutement et ta **prospection commerciale**
      // - **6h** de vidéos sur les nouvelles méthodes de sourcing 3.0 (sourcing sur canaux non conventionnels, IA, copywriting etc.)
      // `}
      //             </Markdown>
      //             <h3>Combien ça coûte&nbsp;?</h3>
      //             <PlanComparison
      //               items={[
      //                 {
      //                   plan: 'none',
      //                   title: (
      //                     <>
      //                       <strong>2 300€</strong>
      //                     </>
      //                   ),
      //                 },
      //                 {
      //                   plan: 'starter',
      //                   title: (
      //                     <>
      //                       <strong>2 150€</strong>
      //                     </>
      //                   ),
      //                   details: (
      //                     <>
      //                       Economie de <strong>150€</strong>
      //                     </>
      //                   ),
      //                 },
      //                 {
      //                   plan: 'pro',
      //                   title: <strong>2 000€</strong>,
      //                   details: (
      //                     <>
      //                       Economie de <strong>300€</strong>
      //                     </>
      //                   ),
      //                 },
      //               ]}
      //             ></PlanComparison>
      //           </div>
      //         ),
      //       },
      //       {
      //         id: 'cold-call',
      //         title: 'Développe ta base de clients grâce au Cold Call',
      //         subtitle: 'Valide ton offre et décroche des rendez-vous en 3h',
      //         type: 'workshop',
      //         icon: <Md11Mp />,
      //         details: (
      //           <div className="prose prose-sm text-left">
      //             <Image src="/images/tools/vanessa-amsili.jpg" width={129} height={150} alt="Vanessa Amsili" />
      //             <Markdown
      //               components={{
      //                 a: ({ children, href }) => (
      //                   <a href={href} target="_blank" rel="noreferrer">
      //                     {children}
      //                   </a>
      //                 ),
      //               }}
      //             >
      //               {`## Animé par [Vanessa Amsili](https://www.linkedin.com/in/vanessa-amsili)

      // - **avant l'atelier**, tu prépares ta liste de numéros, on t'envoie un guide, tu prépares ton pitch, et on te le corrige.
      // - **pendant l'atelier**, tu poses tes questions, on parle des objections tous les 12 (vous 10, Vanessa, et moi)
      // - et ensuite on vous met par groupe de 2, et vous commencez à appeler.

      // L'énergie est folle, personne n'a envie de s'arrêter au bout de 3h.
      // `}
      //             </Markdown>
      //             <h3>Combien ça coûte&nbsp;?</h3>
      //             <PlanComparison items={pricingAtelierItems} />
      //           </div>
      //         ),
      //       },
      {
        id: 'requete-booleenne',
        title: 'Développe ta base de candidats avec Benoît Bliard',
        subtitle: 'Google Search - Initiation à l’Open web sourcing - 1 fois par trimestre',
        type: 'workshop',
        icon: <Md11Mp />,
        details: (
          <div className="prose prose-sm text-left">
            <Image src="/images/tools/benoit-bliard.jpg" width={129} height={150} alt="Benoît Bliard" />
            <Markdown>
              {`## Animé par [Benoît Bliard](https://www.linkedin.com/in/benoitbliard)

- Regarde le [Replay de présentation](https://www.youtube.com/watch?v=_Me0SX32yI4)

Comment une requête avancée sur Google peut vous permettre d'identifier n'importe quels CV, profils ou compétences sur l'Open Web : réseaux sociaux, sites communautaires, site écolé, sites entreprises, hébergeurs de CV, blogs, pages personnels, etc.
      `}
            </Markdown>
            <h3>Combien ça coûte&nbsp;?</h3>
            <p>
              On vous aide à mutualiser les coûts de la formation en organisant des groupes et passer de{' '}
              <strong className="line-through">1 200€</strong> à <strong>500€</strong> par personne.
            </p>
            <PlanComparison items={pricingAtelierItems} />
          </div>
        ),
      },
      //       {
      //         id: 'leadership',
      //         title: 'Leadership: Passe au niveau supérieur',
      //         subtitle: 'Audit personnalisé de ton activité',
      //         type: 'workshop',
      //         icon: <Md11Mp />,
      //         details: (
      //           <div className="prose prose-sm text-left">
      //             <Image src="/images/tools/kemra-jaafar.jpg" width={150} height={150} alt="Joanna Bouy" />
      //             <Markdown>
      //               {`## Animé par [Kemra Jaafar](https://www.linkedin.com/in/kemra-jaafar-4644b8173) de Recrutech & Co

      // - 30 min d’échange sur tous les pans de ton activité (prospection, facturation, sourcing, recouvrement, organisation, outils …)
      // + 15 min de plan d’action
      // `}
      //             </Markdown>
      //             <h3>Combien ça coûte&nbsp;?</h3>
      //             <PlanComparison items={pricingAtelierItems}></PlanComparison>
      //           </div>
      //         ),
      //       },
      //       {
      //         id: 'leadership',
      //         title: 'Développe ton Leadership',
      //         subtitle: 'Pose les limites avec ton client pour mieux appréhender la négociation',
      //         type: 'workshop',
      //         icon: <Md11Mp />,
      //         details: (
      //           <div className="prose prose-sm text-left">
      //             <Image src="/images/tools/joanna-bouy.jpg" width={150} height={150} alt="Joanna Bouy" />
      //             <Markdown>
      //               {`## Animé par [Joanna Bouy](https://www.linkedin.com/in/joanna-bouy)

      // - Cas concrets: à partir cas précis (négociations tarifaires, demandes de clients déraisonnables, etc.)
      // `}
      //             </Markdown>
      //             <h3>Combien ça coûte&nbsp;?</h3>
      //             <PlanComparison items={pricingAtelierItems}></PlanComparison>
      //           </div>
      //         ),
      //       },
      //       {
      //         id: 'hello-work',
      //         title: 'Accès Hello Work',
      //         subtitle: 'la référence en matière de CVThèque',
      //         icon: <Md11Mp />,
      //         type: 'tool',
      //         details: (
      //           <div className="prose prose-sm text-left">
      //             <Image src="/images/tools/hello-work.png" width={125} height={38} alt="Hello Work" />
      //             <Markdown>
      //               {`
      // - Base de données de CVs qualifiés
      // - Fonctionnalités de recherche avancées
      // - Gestion des candidatures et suivi des candidats
      // - Utilise l'outil en marque blanche et **reste indépendant**
      // `}
      //             </Markdown>
      //             <h3>Combien ça coûte&nbsp;?</h3>
      //             <PlanComparison
      //               items={[
      //                 {
      //                   plan: 'none',
      //                   title: (
      //                     <>
      //                       Environ <strong className="whitespace-nowrap">8 000€</strong>
      //                     </>
      //                   ),
      //                 },
      //                 {
      //                   plan: 'starter',
      //                   title: <>Pas encore négocié</>,
      //                   details: (
      //                     <>
      //                       Interessé? Contacte{' '}
      //                       <a href={whatsappDorothee} target="_blank" rel="noopener noreferrer">
      //                         Dorothée
      //                       </a>
      //                     </>
      //                   ),
      //                 },
      //                 {
      //                   plan: 'pro',
      //                   title: <>Pas encore négocié</>,
      //                 },
      //               ]}
      //             ></PlanComparison>
      //           </div>
      //         ),
      //       },
      {
        id: 'apero',
        title: '⁠Cafés virtuels, apéros en présentiel',
        subtitle: 'Viens échanger avec d’autres recruteurs des meilleurs outils, et pratiques du marché',
        type: 'apero',
        icon: <FaCocktail />,
        details: (
          <div className="prose prose-sm text-left">
            <Markdown>
              {`Sors de la solitude pour atteindre ton plein potentiel

**Le vendredi à 10h, on se retrouve pour un café virtuel :**
- Tu te connectes directement depuis le calendrier Headlinker
- Les sujets sont libres
- Tu as la possibilité de t’isoler dans une salle avec 1 ou 2 autres recruteurs s’il y a plusieurs conversations

**1 fois par mois, on organise un apéro, en présentiel, à Nantes, Bordeaux, Toulouse, Québec, Montréal ou Paris**
- Regarde dans notre onglet [Ambassadeurs](/contact), s'il y en a un dans ta ville, c'est lui qui organise les apéros ! 
- Dès que ton inscription est validée, tu rejoins son groupe WhatsApp pour être informé des prochaines dates
- Si tu veux devenir Ambassadeur Headlinker dans ta ville, envoie un message à Dorothée !
- Rien de tel pour créer de vraies relations
`}
            </Markdown>
            {/* <h3>Combien ça coûte&nbsp;?</h3>
            <PlanComparison items={pricingAtelierItems} /> */}
          </div>
        ),
      },
    ]}
  />
);

export const mainFeatures = (
  <RotatingFeatures
    className="mt-5"
    title="Valorise ton vivier de candidats et accélère tes process"
    subtitle={
      false && (
        <>
          L’objectif d’Headlinker est de te permettre d’<strong>augmenter tes revenus</strong>, la <strong>satisfaction</strong> de tes clients et
          celle de tes candidats, grâce à notre plateforme <strong>sécurisée</strong>
        </>
      )
    }
    items={[
      {
        id: 'candidate',
        title: <>Ton candidat n‘a pas été choisi par ton client&nbsp;?</>,
        subtitle: 'N’attends pas qu’il soit déçu, ou qu’il signe ailleurs, sans toi',
        icon: <MdCalendarViewDay />,
        details: (
          <div className="prose prose-sm text-left">
            <h4>Propose ton candidat sur Headlinker</h4>
            <ol>
              <li>Propose ton candidat de manière anonyme</li>
              <li>Décris sa recherche</li>
              <li>Demande la prime qui te semble juste pour le proposer préqualifié et actif à la communauté</li>
              <li>Reçois des propositions de mission d’autres recruteurs professionnels</li>
              <li>S’il va au bout du process, empoche ta prime.</li>
            </ol>
            <h5 className="font-bold">Combien ça coûte&nbsp;?</h5>
            <PlanComparison
              items={[
                {
                  plan: 'starter',
                  title: (
                    <>
                      <strong>10%</strong> de la prime
                    </>
                  ),
                  details: (
                    <>
                      Exemple:
                      <br />
                      Candidat placé pour une prime de <strong>4 500€</strong>
                      <br />
                      <strong>450€</strong> à payer à Headlinker
                    </>
                  ),
                },
                // {
                //   plan: 'pro',
                //   title: <strong>Aucun frais</strong>,
                //   details: (
                //     <>
                //       Exemple:
                //       <br />
                //       Candidat placé pour une prime de <strong>4 500€</strong>
                //       <br />
                //       <strong>0€</strong> à payer à Headlinker
                //     </>
                //   ),
                // },
              ]}
            ></PlanComparison>
          </div>
        ),
      },
      {
        id: 'mission',
        title: <>Tu ne trouves pas de candidat pour la mission de ton client&nbsp;?</>,
        subtitle: 'Tu n’as pas assez de temps ? La mission est complexe ?',
        icon: <Md11Mp />,
        details: (
          <div className="prose prose-sm text-left">
            <h4>Propose ta mission sur Headlinker</h4>
            <ol>
              <li>Décris le détail de ta mission</li>
              <li>Détermine le montant de la prime que tu es prêt à verser</li>
              <li>Valide ta mission sur notre plateforme sécurisée</li>
              <li>Reçois des propositions de candidats</li>
              <li>Présente les candidats proposés à ton client</li>
              <li>Si l’un d’eux signe chez ton client, paye la prime au recruteur qui te l’aura présenté</li>
            </ol>
            <h5 className="font-bold">Combien ça coûte&nbsp;?</h5>
            <PlanComparison
              items={[
                {
                  plan: 'starter',
                  title: (
                    <>
                      <strong>10%</strong> de la prime
                    </>
                  ),
                  details: (
                    <>
                      Exemple:
                      <br />
                      Candidat placé pour une prime de <strong>4 500€</strong>
                      <br />
                      <strong>450€</strong> à payer à Headlinker
                    </>
                  ),
                },
                // {
                //   plan: 'pro',
                //   title: <strong>Aucun frais</strong>,
                //   details: (
                //     <>
                //       Exemple:
                //       <br />
                //       Candidat placé pour une prime de <strong>4 500€</strong>
                //       <br />
                //       <strong>0€</strong> à payer à Headlinker
                //     </>
                //   ),
                // },
              ]}
            ></PlanComparison>
          </div>
        ),
      },
      {
        id: 'search',
        title: <>Tu veux gagner du temps sur une mission ?&nbsp;?</>,
        subtitle: 'Consulte notre CVThèque Off-Market exclusive de candidats actifs ET passifs',
        icon: <MdProductionQuantityLimits />,
        details: (
          <div className="prose prose-sm text-left">
            <h4>Consulte la CVthèque exclusive Headlinker</h4>
            <ol>
              <li>Cette base est constituée de candidats actifs ET passifs, sourcés par nos recruteurs, et à l’écoute du marché.</li>
              <li>Choisis celui qui t’intéresse et accède immédiatement aux coordonnées du recruteur de ce candidat</li>
              <li>
                Présente-lui ta mission, s’il pense que son candidat peut être intéressé, il le contacte pour obtenir son accord, et valide ta
                proposition
              </li>
              <li>L’identité du candidat t’est alors dévoilée : tu peux le contacter et le présenter à ton client</li>
              <li>S’il va au bout du process de ton client, tu paies la prime prévue intialement avec le recruteur.</li>
            </ol>
            <h5 className="font-bold">Combien ça coûte&nbsp;?</h5>
            <PlanComparison
              items={[
                {
                  plan: 'starter',
                  title: (
                    <>
                      <strong>10%</strong> de la prime
                    </>
                  ),
                  details: (
                    <>
                      Exemple:
                      <br />
                      Candidat placé pour une prime de <strong>4 500€</strong>
                      <br />
                      <strong>450€</strong> à payer à Headlinker
                    </>
                  ),
                },
                // {
                //   plan: 'pro',
                //   title: <strong>Aucun frais</strong>,
                //   details: (
                //     <>
                //       Exemple:
                //       <br />
                //       Candidat placé pour une prime de <strong>4 500€</strong>
                //       <br />
                //       <strong>0€</strong> à payer à Headlinker
                //     </>
                //   ),
                // },
              ]}
            ></PlanComparison>
          </div>
        ),
      },
    ]}
  />
);

const mainBenefits = [
  {
    id: 'coaching',
    variant: 'primary',
    when: 'Mardi matin & Jeudi après midi',
    title: 'Coaching en prospection B2B',
    subtitle: (
      <>
        Fini la procrastination : chaque semaine, on prospecte ensemble pour <strong>décrocher plus de contrats</strong>.
      </>
    ),
    benefits: [
      'Tu bloques un créneau fixe dans ton agenda, fini les reports',
      "Tu prospectes avec un coach et bénéficie d'outils à ton top + effet motivation",
      'Tu gagnes 1h30 de prospection productive, garantie chaque semaine',
      'Résultat : tu avances sur ta base clients sans y penser et tu gardes le rythme',
      "🎁 Bonus : Bénéficie d'un E-book avec toutes les stratégies pour démarcher efficacement",
    ],
  },
  {
    id: 'team',
    variant: 'success',
    when: 'Réunion hebdomadaire le lundi matin',
    title: "Rejoins le club Headlinker - Passe à l'étape supérieur",
    subtitle:
      "Accélère ton business en t'appuyant sur la force du réseau Headlinker. Acquiers des contrats en dehors de ton domaine, délègue ce qui te prend trop de temps et co-construis tes outils avec le réseau réuni.",
    benefits: [
      "Tu n'as pas le temps de gérer certains contrats ? Le réseau prend le relais ou tu recommandes facilement.",
      "Tu n'es pas expert sur un sujet ? Confie certains contrats à des spécialistes du collectif.",
      'Tu veux chasser de nouveaux clients mais pas sourcer en interne ? Le réseau complète tes forces.',
      "Tu n'es plus seul : tu profites d'un collectif soudé, d'échanges et de soutien chaque semaine.",
      'Tu peux donner facilement à un créateur pour sécuriser une mission et avancer plus vite.',
    ],
  },
  {
    id: 'coffee',
    variant: 'info',
    when: 'Tous les vendredis à 10h',
    title: 'Café Réseau - Crée de vraies connexions',
    subtitle: "Sors de la solitude, échange, partage et progresse aux côtés d'indépendants comme toi.",
    benefits: [
      '✨ Chaque vendredi à 10h, café virtuel',
      " • Tu te connectes depuis l'agenda Headlinker",
      " • Les sujets sont libres → partage d'astuces, outils, réussites & galères",
      ' • Possibilité de rejoindre une salle plus restreinte (2-3 recruteurs) pour des échanges ciblés',
      '🔥 1 fois par mois, apéro en présentiel (Nantes, Bordeaux, Rennes, Toulouse, Quimper, Lyon, Paris)',
      ' • Organisé par un ambassadeur Headlinker dans ta ville',
      ' • Tu rejoins son groupe WhatsApp pour être tenu informé des prochaines dates',
      ' • Objectif : déconnecter, networker, créer de vraies relations',
    ],
  },
];

const AvantagesPage = () => {
  const { signin } = useAuthModal();
  const { data } = useQuery(LIST_EVENTS, { variables: {} });
  const { items: events = [] } = data?.events || {};
  return (
    <HeaderLayout
      title="Avantages Abonnement Headlinker : Boostez votre activité de recrutement"
      description="Découvrez tous les avantages de l’abonnement Headlinker pour recruteurs indépendants : accès à des outils de sourcing, formations, coachings, événements, offres partenaires négociées et réseau d’experts. Comparez nos formules et développez votre activité de recrutement grâce à Headlinker."
    >
      <Hero
        meta="Formations & réductions exclusives"
        title={
          <>
            Développe ton activité <Highlight className="my-1">plus vite</Highlight>
            <br />
            <Highlight>en dépensant moins</Highlight>
          </>
        }
        description="Ton abonnement Headlinker ne se limite pas à un accès plateforme : il t’ouvre aussi les portes de coachings, formations, événements 
et d’offres exclusives négociées pour la communauté."
        cta={<Button variant="cta">Rejoins la communauté</Button>}
      />
      {/* <Section
        className="bg-gray-50"
        title={<>Headlinker, ça sert à quoi&nbsp;?</>}
        subtitle={
          <>
            L'objectif d'Headlinker est de permettre aux recruteurs externes d'augmenter leurs revenus, la satisfaction de leurs clients et celle de
            leurs candidats, grâce à notre plateforme sécurisée.
          </>
        }
      >
        {mainFeatures}
      </Section> */}

      <Section
        title={<>Comment ça fonctionne au quotidien&nbsp;?</>}
        subtitle={<>Découvre tous les avantages concrets de ton adhésion à la communauté Headlinker</>}
      >
        <div className="grid gap-8 mt-8 max-w-4xl mx-auto">
          {mainBenefits.map(({ variant, id, ...benefit }) => (
            <CardBenefit key={id} {...benefit} variant={variant as keyof React.ComponentProps<typeof CardBenefit>['variant']} />
          ))}
        </div>
      </Section>
      {/* <Section className="bg-gray-50" id="features">
        {bonusFeatures}
      </Section> */}
      <Section
        variant="2columns"
        title="Accède à des offres exclusives réservées aux membres Headlinker"
        subtitle={
          <>
            Ton abonnement ne t’apporte pas seulement des formations et du coaching.
            <br />
            Il t’ouvre aussi l’accès à des outils premium et services partenaires à prix négociés, spécialement pour la communauté.
            <div>
              <Button className="mt-4" variant="cta" onClick={() => signin()}>
                Deviens membre pour en profiter
              </Button>
            </div>
          </>
        }
        ratio="1:2"
      >
        <ExclusiveOffer
          image="/images/tools/trimoji.png"
          title="Ajoute une nouvelle source de revenus à ton offre des demain avec Trimoji"
          subtitle="Avec Trimoji, tu ajoutes immédiatement un outil d'audit d'équipe facturable à ton offre de recruteur :"
          benefits={[
            'Augmente ta valeur perçue : propose une évaluation claire des équipes à tes clients',
            'Génère un revenu supplémentaire : facture un audit dès le premier jour',
            'Renforce ton image auprès des candidats en leur offrant un retour de personnalité professionnel',
            "Reste indépendant : l'outil est en marque blanche, tu le proposes sous ton nom",
            'Gagne du temps : en 15 min, une analyse de qualité différenciante',
          ]}
          ctaText="→ Accéde à la vidéo de présentation TRIMOJI"
          ctaHref="https://www.youtube.com/watch?v=gMXd7IdJGNM"
          discountLabel="-20%"
        >
          <SpecialOffer
            title="Offre spéciale Headlinker"
            publicPrice="300€/mois + 900€ de formation"
            memberPrice="250€/mois + 600€ de formation"
            description={
              <>
                -17% sur l’abonnement et -33% sur la formation.
                <br />
                Parles-en à Dorothée.
              </>
            }
            ctaText="Profite de cette offre"
            ctaHref={linkedinDorothee}
          />
        </ExclusiveOffer>
        <ExclusiveOffer
          image="/images/tools/benoit-bliard.jpg"
          title="Maîtrise la recherche de candidats comme un pro avec Benoît Bliard"
          subtitle="Avec Benoît Bliard, tu apprends à dénicher tous les potentiels de Google et du web ouvert pour identifier de meilleurs profils."
          benefits={[
            'Formations personnalisées pour devenir un expert des CV, profils et compétences numériques',
            "Optimise ton sourcing grâce à des techniques avancées de recherche pour identifier les candidats n'importe où sur le web",
            'Gagne du temps et élargis ton vivier grâce aux outils de vérification efficaces par les candidats cachés',
            'Réserve ta séance maintenant pour accélérer ta maîtrise des manipulations dans ton sourcing',
          ]}
          ctaText="+ Réserve ta place de formation"
          ctaHref={linkedinDorothee}
          discountLabel="-58%"
        >
          <SpecialOffer
            title="Offre spéciale Headlinker"
            publicPrice="1200€"
            memberPrice="500€"
            description={
              <>
                Profite de cette formation exclusive en groupe pour mutualiser les coûts (au lieu de 1200€, ramené à 500€ par personne).
                <br />
                Parles-en à Dorothée.
              </>
            }
            ctaText="Profite de cette offre"
            ctaHref={linkedinDorothee}
          />
        </ExclusiveOffer>
      </Section>

      <Section title={<>Prochains évènements</>} subtitle={<></>} id="events" className="bg-gray-50">
        <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 mt-5">
          {([...events] as Event[])
            .sort((a, b) => dayjs(a.startAt).diff(dayjs(b.startAt)))
            .filter((event) => dayjs(event.startAt).isAfter(dayjs()))
            .filter((event, index, array) => (event.tool?.type === 'coffee' ? array.findIndex((e) => e.tool?.type === 'coffee') === index : true))
            .map((event) => (
              <li
                key={`${event.name || event.tool.name}_${event.startAt}`}
                className="flex flex-col justify-between rounded-md shadow-sm border border-gray-100 py-1 px-2 list-none"
              >
                <div>
                  <span className="h6 block font-bold">{event.name || event.tool.name}</span>
                  {event.tool.type && <ToolBadge type={event.tool.type as any} />}
                </div>
                <div className="flex items-center justify-between gap-2">
                  <time className="textd-gray-800 text-sm" dateTime={dayjs(event.startAt).format()}>
                    {dayjs(event.startAt).format('LL')}
                  </time>{' '}
                  <strong className="text-xs block italic tet-right">
                    {formatMinutesToHoursAndMinutes(event.duration || event.tool.duration || 0)}
                  </strong>
                </div>
              </li>
            ))}
          <div className="shadow-sm border border-gray-100 py-5 px-2 flex items-center justify-start">
            <span className="h6 block font-bold">
              +{events.filter((event: Event) => dayjs(event.startAt).isAfter(dayjs())).length - 4} évènements
            </span>
          </div>
        </ul>
        <div className="text-center mt-5">
          <button onClick={() => signin('/calendar')} className="link link-primary text-sm mt-2">
            Voir tous les évènements
          </button>
        </div>
      </Section>
      <Section
        id="pricing"
        title={<>Et ça coute combien Headlinker&nbsp;?</>}
        subtitle="Notre service de base est soumis à une cotisation annuelle et une paiement au succès, afin que vous puissiez vous familiariser facilement avec la plateforme et la communauté"
      >
        <Pricing className="mt-5" />
        <div className="text-center mt-5">
          <p className="text-sm text-gray-500 mt-12 mb-2">
            Accès immédiat à une communauté expérimentée et de confiance pour t’accompagner vers des résultats rapides.
          </p>
          <Button variant="cta" onClick={() => signin()}>
            Postule gratuitement
          </Button>
        </div>
      </Section>
    </HeaderLayout>
  );
};

export default AvantagesPage;
